export default class ErrorModalController {
  /* @ngInject*/
  constructor(currentError, $uibModalInstance) {
    // Assign injected values to scope
    this.errorContent = currentError;
    this.$uibModalInstance = $uibModalInstance;
    this.isErrorDetailsCollapsed = true;
  }

  closeModal() {
    this.$uibModalInstance.close();
  }

}



// WEBPACK FOOTER //
// ./client/components/modal/error/modal.component.js